import { Dropdown } from "components/ui";
import { PLACEMENT } from "components/ui/utils/constant";
import { useContext, useEffect, useState } from "react";
import { LuGlobe, LuLock } from "react-icons/lu";
import { CompanyContext } from "contexts/CompanyContext";
import { TbLink, TbLock, TbWorld } from "react-icons/tb";

const YoutubePrivacyLevelDropdown = ({
    post,
    isEditable = true,
    onChange = (privacy_level) => void 0,
    portal = false
}) => {

    const youtubePrivacyLevelsOptions = [
        { id: "public", name: "Public to everyone", description: "Content is visible to everyone on Youtube", icon: <TbWorld className="text-3xl shrink-0 text-primary-600" /> },
        { id: "private", name: "Private", description: "Content is visible only to the video owner", icon: <TbLock className="text-3xl shrink-0 text-red-600" /> },
        { id: "unlisted", name: "Unlisted", description: "Content is visible to anyone with the video link", icon: <TbLink className="text-3xl shrink-0 text-purple-500" /> },
    ];
    
    const { companySocials } = useContext(CompanyContext);
    const integration = companySocials?.find(e => e.type == "youtube");
    const [ youtubePrivacyLevels, setYoutubePrivacyLevels ] = useState(youtubePrivacyLevelsOptions);
    const youtubePrivacyLevel = youtubePrivacyLevelsOptions?.find(e => e.id == post?.preferences?.privacy_level) || youtubePrivacyLevelsOptions?.[0];

    const disabled = !isEditable || !integration;

    useEffect(() => {
        if (!post?.preferences?.privacy_level || !youtubePrivacyLevels?.find(e => e.id == post?.preferences?.privacy_level)) {
            onChange(youtubePrivacyLevels?.[0]?.id);
        }
    }, [youtubePrivacyLevels, post?.preferences?.privacy_level]);


    return (
        <Dropdown
            placement={PLACEMENT.BOTTOM_START}
            parentClassName="flex-1 w-[100%]"
            menuClass={`w-auto ${portal ? "" : "w-full"} p-0 overflow-y-auto`}
            portal={portal}
            disabled={disabled}
            renderTitle={
                <div className={`w-full !p-4 border-b border-tertiary-100 dark:border-gray-700 cursor-pointer ${disabled && `!cursor-default hover:bg-gray-50 dark:hover:bg-gray-700`}`}>
                    <div className='flex items-center gap-2.5'>
                        {youtubePrivacyLevel?.icon}
                        <div className="flex flex-col w-full overflow-hidden">
                            <b className="font-black text-tertiary-700 dark:text-gray-200">{youtubePrivacyLevel?.name}</b>
                            <small className="text-xs font-normal w-full whitespace-nowrap overflow-hidden text-ellipsis">{youtubePrivacyLevel?.description}</small>
                        </div>
                    </div>
                </div>
            }
        >
            {youtubePrivacyLevels?.map((_youtubePrivacyLevel) => (
                <Dropdown.Item key={_youtubePrivacyLevel?.id} onClick={() => onChange(_youtubePrivacyLevel?.id)} className={`flex items-center gap-2.5 py-2 px-4 ${youtubePrivacyLevel?.id == _youtubePrivacyLevel?.id && `bg-primary-50 dark:bg-primary-900`}`}>
                    {_youtubePrivacyLevel?.icon}
                    <div className="flex flex-col flex-1">
                        <b>{_youtubePrivacyLevel?.name}</b>
                        <small className="font-normal">{_youtubePrivacyLevel?.description}</small>
                    </div>
                </Dropdown.Item>
            ))}
        </Dropdown>
    )
}

export default YoutubePrivacyLevelDropdown;